export class FileExternal {
	public service: string;
	public name: string;
	public url: string;
	public mimeType: string;
	public size: number | null;
}
